<template>
    <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd">
            <path
                d="M74.872 9c1.5 0 2.058.12 2.61.416.475.254.848.627 1.102 1.102.295.552.416 1.11.416 2.61v69.744c0 1.5-.12 2.058-.416 2.61a2.649 2.649 0 0 1-1.102 1.102c-.552.295-1.11.416-2.61.416H21.128c-1.5 0-2.058-.12-2.61-.416a2.649 2.649 0 0 1-1.102-1.102c-.295-.552-.416-1.11-.416-2.61V13.128c0-1.5.12-2.058.416-2.61a2.649 2.649 0 0 1 1.102-1.102c.552-.295 1.11-.416 2.61-.416h53.744ZM28 28h40M28 44.5h20"
            />
        </g>
    </svg>
</template>
